import React, { FC, useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { ProfileName } from './ProfileName';
import Modal from '../../Modal/NewModal';

interface Props {
  isOpen: boolean;
  setOpen: (x: boolean) => void;
  onProfileNameChange: (name: string) => void;
}

export const EditNameModal: FC<Props> = ({ isOpen, setOpen, onProfileNameChange }) => {
  const [validProfileName, setValidProfileName] = useState<string>('');
  const onClose = () => setOpen(false);

  const handleApply = useCallback(() => {
    onProfileNameChange(validProfileName);
    toast.info('To save changes click on Save or Save as', {
      position: 'top-center',
      hideProgressBar: true,
      pauseOnHover: true,
      draggable: true
    });
  }, [onProfileNameChange, validProfileName]);

  const handleInvalidName = useCallback(() => setValidProfileName(''), []);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header="Edit profile name"
      actions={[
        { title: 'Cancel', kind: 'secondary', onClick: onClose },
        { title: 'Apply', kind: 'primary', onClick: handleApply, isDisabled: () => !validProfileName }
      ]}
      size="default"
    >
      <div className="p-6 pb-20 w-full" data-testid="marketing-edit-name-profile-modal">
        <h2 className="mb-6 text-gray-45">Enter a new name for this profile.</h2>
        <ProfileName onInvalidName={handleInvalidName} onValidName={setValidProfileName} />
      </div>
    </Modal>
  );
};
